<template>
    <div>
        {{ order.streetAddress1 }}<br v-if="order.streetAddress1">
        {{ order.streetAddress2 }}<br v-if="order.streetAddress2">
        {{ order.streetAddress3 }}<br v-if="order.streetAddress3">
        {{ order.city }}<span v-if="order.stateOrProvince">, </span>
        {{ order.stateOrProvince }}<span v-if="order.zipCode">, </span>
        {{ order.zipCode }}<span v-if="order.country">, </span>
        {{ order.country }}
    </div>
</template>

<script>
export default {
    name: 'ConsumerAddress',
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
};
</script>
